import $ from 'jquery';
// import "foundation-sites";
// import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
// window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).ready(function ($) {

    $(document).foundation();

// function appLoad() {
    var tag = document.createElement('script');
    tag.src = "//www.youtube.com/player_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.


// jQuery  = $.noConflict()
// jQuery(window).load(function ($) {
    var player;
    function onYouTubePlayerAPIReady() {
        player = new YT.Player('player', {
            playerVars: {
                'autoplay': 0,
                'widget_referrer': 'https://gigroup.de',
                'enablejsapi': 1,
                'controls': 1,
                "host": 'https://www.youtube.com',
                'autohide': 1,
                'origin': "https://gigroup.de",
                'mute': 1,
                'wmode': 'opaque'
            },
            videoId: 'GyB-hGSeYUk',
            // events: {
            //   'onReady': }
        });
    }


    setTimeout(function () {
        onYouTubePlayerAPIReady()
    }, 1000)


    jQuery('.image-wrap').click(function () {
        jQuery("html, body").animate({scrollTop: jQuery('#jobliste').offset().top}, 1000);
    })
    // jQuery(document).foundation();
    var url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    var title = encodeURI(document.title);
    jQuery('.social-fb a').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + url);
    jQuery('.social-tw a').attr('href', 'https://twitter.com/share?url=' + url);
    jQuery('.social-gp a').attr('href', 'https://plus.google.com/share?url=' + url);
    jQuery('.social-xi a').attr('href', 'https://www.xing-share.com/app/user?op=share;sc_p=xing-share;url=' + url);
    jQuery('.social-li a').attr('href', 'http://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title);
    jQuery('.social-wa a').attr('href', 'whatsapp://send?text=' + url);
    jQuery('.social-email a').attr('href', 'mailto:?body=' + url);

    jQuery('.showsubfilter').click(() => {
        jQuery('.subfilter').toggleClass('show')
        event.preventDefault();
    })


    // 4. The API will call this function when the video player is ready.
    // function onPlayerReady(event) {
    //   event.target.mute();
    // }


    jQuery('#myVideoModal').on('hide', function () {
        player.pauseVideo();

    })

    jQuery('#myVideoModal').on('show', function () {
        player.playVideo();

    })


    // jQuery(document).on('click', 'a', function(event) {
    //     event.preventDefault();

    //     jQuery('html, body').animate({
    //         scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top
    //     }, 500);
    // });

    jQuery('.image-details').click(function () {
        jQuery(this).parent().parent().find('input').prop("checked", true).trigger("click");
    })


})


// }
// window.addEventListener("load", appLoad, false);
